import React from 'react';
import { experimental } from '@trp-beacon-ui-kit/react-theme/warnings';

import InputField from '../InputField';

const SelectField = (props) => <InputField elementType="select" {...props} />;

export default experimental(SelectField);
